import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, message } from "antd";
import { Link } from "react-router-dom";
import rightPicture from "../../../Assests/Images/login.png";
import Logo from "../../../Assests/Images/logo.svg";
import { authAPI } from "../../../utils/api";
import "./style.css";

const Login = ({ setUser }) => {
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await authAPI.login(values.email, values.password);

      // Store token
      localStorage.setItem("authToken", response.token);
      localStorage.setItem("user", JSON.stringify(response.user));

      messageApi.success("Login successful!");

      // Switch to user route
      setTimeout(() => {
        setUser(response.user);
        navigate("/overview");
      }, 500);
    } catch (error) {
      messageApi.error(error.message || "Login failed. Please try again.");
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {contextHolder}
      <div className="login-card">
        <div className="left-section">
          <div className="logo-container">
            <img src={Logo} alt="Logo Text" className="logo" />
          </div>

          <div className="content-wrapper">
            <div className="content-heading">
              Welcome Back <span>👋</span>
            </div>
            <div className="sub-heading">
              Today is a new day. It's your day. You shape it. Sign in to start
              managing your projects.
            </div>

            <Form
              name="login"
              className="login-form"
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
            >
              <Form.Item
                label={<span className="form-label">Email</span>}
                name="email"
                rules={[
                  { required: true, message: "Please enter your email!" },
                  { type: "email", message: "Please enter a valid email!" },
                ]}
              >
                <Input
                  type="email"
                  placeholder="Enter your email."
                  className="form-input"
                />
              </Form.Item>

              <Form.Item
                label={<span className="form-label">Password</span>}
                name="password"
                rules={[
                  { required: true, message: "Please enter your password!" },
                ]}
              >
                <Input.Password
                  placeholder="Enter your password."
                  className="form-input"
                />
              </Form.Item>

              <Button
                type="primary"
                htmlType="submit"
                className="submit-button"
                loading={loading}
              >
                Login
              </Button>
            </Form>
            <div className="rights-tag">© 2026 ALL RIGHTS RESERVED</div>
          </div>
        </div>

        <div className="right-section">
          <div className="dashboard-preview">
            <img src={rightPicture} alt="Dashboard Preview" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
